export const UPDATE_SITE_DATA = 'UPDATE_SITE_DATA';
export const ADD_DOCUMENT_ELEMENTS = 'ADD_DOCUMENT_ELEMENTS';
